import { useState, useEffect } from 'react';

export const useDescriptionContentUtils = (initialContent) => {
  const [content, setContent] = useState(initialContent);// 입력받은 파라미터로 초기값 설정
  const updateContent = () => {// content 변경 함수
    const htmlContent = document.querySelector('meta[name="description"]'); // <content> 태그 찾기
    htmlContent.setAttribute('content', content);
  };
  useEffect(updateContent, [content]);// content 값이 바뀔 때마다 content 변경 함수 실행
  return setContent;// content 변경할 수 있는 setContent 반환
};

export default {useDescriptionContentUtils};
